<template>
    <v-row justify="start" class="flex-nowrap ma-n4" :class="{ 'mt-n12': isItemSequent }">
        <v-col cols="auto" class="pa-4" :style="{ opacity: isItemSequent ? 0 : 1 }">
            <v-avatar color="grey-f7" height="28px!important" width="28px!important">
                <v-img>
                    <template #placeholder>
                        <v-icon small color="grey lighten-2"> mdi-account </v-icon>
                    </template>
                </v-img>
            </v-avatar>
        </v-col>
        <v-col class="pa-4">
            <div class="d-flex align-baseline" v-if="!isItemSequent">
                <span class="font-size-14 font-weight-bold"> {{ message.name }} </span>
            </div>
            <v-row align="end" class="ma-n4 flex-nowrap">
                <v-col cols="auto" class="pa-4" style="max-width: calc(100% - 36px)">
                    <v-card color="grey-f7" class="mt-4" flat min-height="36">
                        <v-card-text class="py-8 px-12 font-size-14" style="word-break: break-all">
                            <div v-html="html"></div>
                        </v-card-text>
                    </v-card>
                </v-col>
                <v-col cols="auto" class="pa-4" :style="{ opacity: isTimeSequent ? 0 : 1 }">
                    <span class="font-size-10">
                        {{ time }}
                    </span>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import xss from "xss";
import dayjs from "@/plugins/vue-dayjs";
import { mapState } from "vuex";
import { initLectureChatMessage } from "@/store/lecture/chat/chat.inits";
export default {
    props: {
        index: { type: Number, default: 0 },
        message: { type: Object, default: initLectureChatMessage },
    },
    computed: {
        ...mapState("lecture/chat", ["messages"]),
        time() {
            return dayjs(this.message?.createdAt).format("HH:mm");
        },
        isItemSequent() {
            if (this.index == 0) return false;
            const prev = this.messages[this.index - 1];
            return prev?._user == this.message?._user;
        },
        isTimeSequent() {
            if (this.index == this.messages.length - 1) return false;

            const next = this.messages[this.index + 1];
            if (next?._user != this.message?._user) return false;

            return dayjs(next?.createdAt).format("HH:mm") == this.time;
        },
        html() {
            let regex = /(https?:\/\/[^\s]+)/g;
            return xss(this.message.message, { allowList: [] }).replaceAll(regex, (href) => `<a href="${href}" target="_blank">${href}</a>`);
        },
    },
};
</script>

